const getField = (name) => name || 'This field';
const errors = {
  INVALID_EMAIL: 'Please enter a valid email',
  INVALID_STRING: 'Please enter a valid string',
  INVALID_PHONE: 'Please enter a valid phone number',
  INVALID_URL: 'Please enter a valid Url',
  INVALID_PASSWORD:
    'Password must include at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., !@#$%^&*()_+-=[]{}|;:\'",.<>?/~).',
  REQUIRED: (fieldName) => `${getField(fieldName)} is required.`,
  MIN_LENGTH: (fieldName, minLength) =>
    `${getField(fieldName)} should have at least ${minLength} characters.`,
  MAX_LENGTH: (fieldName, maxLength) =>
    `${getField(fieldName)} should have at most ${maxLength} characters.`,
  EMPTY_FIELD: (fieldName) => `${getField(fieldName)} cannot be empty`,
  ONLY_LETTERS: (fieldName) => `${getField(fieldName)} must contain only letters`,
  INVALID_BUSINESS_NAME: (fieldName) =>
    `${getField(
      fieldName
    )} may only contain letters, numbers, spaces and these characters: . , & ' ( ) / -`
};

export { errors };
